<span [class]="classes()">
  <span class="ntt-avatar__content">
    @if (showImage()) {
      <img
        class="ntt-avatar__image"
        [src]="src()"
        [alt]="alt()"
        [attr.width]="imageSize()"
        [attr.height]="imageSize()"
        [attr.loading]="imageLoading()"
        [attr.fetchpriority]="imageFetchPriority()"
        decoding="async"
        (error)="onImageError()"
      />
      <span class="ntt-avatar__image-overlay"></span>
    } @else if (showInitials()) {
      <span class="ntt-avatar__initials">{{ initials() }}</span>
    } @else if (showPlaceholder()) {
      <span class="ntt-avatar__placeholder">
        @if (hasCustomContent()) {
          <ng-content select="[nttAvatarContent]" />
        } @else {
          <span class="ntt-avatar__icon icon-user-01"></span>
        }
      </span>
    }
  </span>

  <!-- Status indicators -->
  @if (showOnlineIndicator() && !verified() && !hasCompanyIcon()) {
    <ntt-avatar-online-indicator [size]="size()" [online]="isOnline()" />
  }
  @if (verified() && !showOnlineIndicator() && !hasCompanyIcon()) {
    <ntt-avatar-verified-icon [size]="size()" />
  }
  @if (hasCompanyIcon()) {
    <ng-content select="ntt-avatar-company-icon" />
  }
</span>
